// extracted by mini-css-extract-plugin
export default {"izjaveContainer":"IzjavePolaznika_izjaveContainer__Yj4LV","izjavaItem":"IzjavePolaznika_izjavaItem__hAKrS"};